import styled from 'styled-components';

export const KaligrafieWorkshopStyled = styled.div``;
